(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demo-scrolly"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStory(story) {
    var stage = story.querySelector('.scrolly-story__stage');
    var steps = Array.prototype.slice.call(story.querySelectorAll('[data-scrolly-step]'));
    var caps = Array.prototype.slice.call(story.querySelectorAll('[data-scrolly-cap]'));
    var n = steps.length;
    if (!stage || !n) return;

    var imgs = [];
    var wins = [];
    for (var s = 0; s < n; s++) {
      imgs.push(steps[s].querySelector('.scrolly-shot'));
      wins.push(steps[s].querySelector('[data-scrolly-window]'));
    }

    var dots = document.createElement('div');
    dots.className = 'scrolly-story__dots';
    var dotEls = [];
    for (var k = 0; k < n; k++) {
      var dot = document.createElement('span');
      dot.className = 'scrolly-story__dot';
      dots.appendChild(dot);
      dotEls.push(dot);
    }
    (story.querySelector('[data-scrolly-text]') || stage).appendChild(dots);

    // Each step's scroll budget = a rest beat (dwell, split lead/tail) plus its
    // pan distance / PAN_SPEED — so every screenshot pans at the SAME visual
    // speed no matter how long it is, and shorter ones simply take less scroll.
    var PAN_SPEED = 0.9;
    var starts = [];
    var pans = [];
    var spans = [];
    var dwell = 0;
    var total = 0;

    function measure() {
      dwell = Math.round(window.innerHeight * 0.5);
      var staticHold = Math.round(window.innerHeight * 0.85);
      var acc = 0;
      for (var i = 0; i < n; i++) {
        var isStatic = steps[i].hasAttribute('data-scrolly-static');
        var over = 0;
        if (!isStatic && imgs[i] && wins[i]) over = Math.max(0, imgs[i].offsetHeight - wins[i].clientHeight);
        starts[i] = acc;
        pans[i] = over;
        spans[i] = isStatic ? staticHold : (dwell + over / PAN_SPEED);
        acc += spans[i];
      }
      total = acc;
      story.style.minHeight = (stage.offsetHeight + total) + 'px';
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = -1;
    function go(i) {
      if (i === current) return;
      var prev = current;
      current = i;
      var fwd = prev < 0 || i > prev;
      for (var j = 0; j < n; j++) {
        var fig = steps[j];
        if (j === i) {
          fig.classList.remove('is-parked-left', 'is-parked-right');
          if (prev >= 0 && !reduce) {
            // jump to the entry side without animating, then slide in
            fig.style.transition = 'none';
            fig.classList.add(fwd ? 'is-parked-right' : 'is-parked-left');
            void fig.offsetWidth;
            fig.style.transition = '';
            fig.classList.remove('is-parked-left', 'is-parked-right');
          }
          fig.classList.add('is-active');
        } else if (j === prev) {
          fig.classList.remove('is-active');
          if (!reduce) fig.classList.add(fwd ? 'is-parked-left' : 'is-parked-right');
        }
        if (caps[j]) caps[j].classList.toggle('is-active', j === i);
        dotEls[j].classList.toggle('is-active', j === i);
      }
    }

    function applyPan(i, sub) {
      var img = imgs[i];
      if (!img) return;
      var shift = pans[i] * sub;
      img.style.transform = shift > 0 ? 'translateY(' + (-shift).toFixed(1) + 'px)' : '';
    }

    var ticking = false;
    function update() {
      ticking = false;
      if (total <= 0) { go(0); applyPan(0, 0); return; }
      var pos = -story.getBoundingClientRect().top;
      if (pos < 0) pos = 0; else if (pos > total) pos = total;
      var i = 0;
      while (i < n - 1 && pos >= starts[i] + spans[i]) i++;
      var local = pos - starts[i];
      var panScroll = pans[i] / PAN_SPEED;
      var sub = 0;
      if (panScroll > 0) {
        var t = (local - dwell * 0.5) / panScroll;
        sub = t < 0 ? 0 : (t > 1 ? 1 : t);
      }
      go(i);
      applyPan(i, sub);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    function remeasure() { measure(); update(); }

    for (var m = 0; m < n; m++) {
      if (imgs[m]) imgs[m].addEventListener('load', remeasure);
    }
    measure();
    go(0);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure);
    update();
  }

  function init() {
    var stories = document.querySelectorAll('[data-scrolly]');
    for (var i = 0; i < stories.length; i++) initStory(stories[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  // Backdrop only after a little scroll, so it's invisible at the top of the hero.
  var ticking = false;
  function sync() {
    ticking = false;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(sync); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  sync();

  // Mobile disclosure.
  var toggle = header.querySelector('[data-header-toggle]');
  var label = header.querySelector('[data-header-toggle-label]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'close' : 'menu';
    });
    header.querySelectorAll('.site-header__link').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (label) label.textContent = 'menu';
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
